import { AxiosError } from 'axios';
import { fetcher, getRequestConfig, UnauthorizedError } from './fetcher';

const Paths = {
  HAS_PAYROLL: '/payroll',
};

const hasPayrollProduct = async (): Promise<boolean> => {
  try {
    await fetcher.get(Paths.HAS_PAYROLL, getRequestConfig());

    return true;
  } catch (error) {
    if ((error as AxiosError)?.response?.status === 404) {
      return false;
    }

    if ((error as AxiosError)?.response?.status === 401) {
      throw new UnauthorizedError((error as AxiosError)?.message);
    }

    throw new Error(`Could not check products - ${error}`);
  }
};

export { hasPayrollProduct, UnauthorizedError };
